// removed by extract-text-webpack-plugin
module.exports = {"header":"PreferencesPage--header--2kYnQEYe","email-format-label":"PreferencesPage--email-format-label--qj6j__Sw","emailFormatLabel":"PreferencesPage--email-format-label--qj6j__Sw","help-text":"PreferencesPage--help-text--sQqsSWiH","helpText":"PreferencesPage--help-text--sQqsSWiH","card":"PreferencesPage--card--1wNUPxCf"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/PreferencesPage/PreferencesPage.css
// module id = 1281
// module chunks = 2